import { format as dateFnsFormat } from 'date-fns';

const replacer = (
  { day, month, year }: { day: string; month: string; year: string },
  format: string
) => {
  return format.replace('MM', month).replace('DD', day).replace('YYYY', year);
};

const dateFormatMap = {
  'MM/DD/YYYY': replacer,
  'DD/MM/YYYY': replacer,
  'YYYY/MM/DD': replacer,
  'MMM DD, YYYY': ({ day, month, year }, _format) => {
    return dateFnsFormat(new Date(`${month}/${day}/${year}`), 'MMM dd, yyyy');
  },
} satisfies Record<string, (...args: any[]) => string>;

export const formatStaticDate = (
  date: string,
  format: keyof typeof dateFormatMap = 'MM/DD/YYYY'
) => {
  if (!date) {
    return '';
  }

  const dateObj = new Date(date) as any;
  if (isNaN(dateObj)) {
    return '';
  }

  const [day, month, year] = [
    String(dateObj.getUTCDate()).padStart(2, '0'),
    String(dateObj.getUTCMonth() + 1).padStart(2, '0'),
    dateObj.getUTCFullYear(),
  ];

  return dateFormatMap[format]({ day, month, year }, format);
};
